var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChalkboardEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "512pt",
    viewBox: "0 -81 512.001 512",
    width: "512pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb211"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "rotate(180 263.027 252.785) scale(1.00392)",
    gradientUnits: "userSpaceOnUse",
    x1: 73.245,
    x2: 472.958,
    xlinkHref: "#a",
    y1: 133.245,
    y2: 532.958
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 64.626,
    x2: 455.393,
    xlinkHref: "#a",
    y1: -16.094,
    y2: 374.673
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb211",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#ff9f19",
    stopOpacity: 0.227
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#ff6f2e",
    stopOpacity: 0.686
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4b3e"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    xlinkHref: "#b",
    y1: 284.835,
    y2: 371.377
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 159.384,
    x2: 431.127,
    y1: 78.664,
    y2: 350.407
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#575c55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45425a"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45425a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347,
    stopColor: "#353343",
    stopOpacity: 0.349
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    xlinkHref: "#c",
    y1: 273.656,
    y2: 348.763
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 407.943,
    x2: 399.648,
    xlinkHref: "#b",
    y1: 377.127,
    y2: 307.389
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 418.449,
    x2: 392.458,
    xlinkHref: "#c",
    y1: 377.153,
    y2: 324.891
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 387.354,
    x2: 387.354,
    xlinkHref: "#a",
    y1: 316.902,
    y2: 354.915
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.824 0h444.352C496.856 0 512 15.145 512 33.828v282.906c0 18.68-15.145 33.825-33.824 33.825H33.824C15.144 350.559 0 335.414 0 316.734V33.828C0 15.145 15.145 0 33.824 0zm0 0",
    fill: "url(#d)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M472.352 345.969H39.648c-18.195 0-32.941-14.75-32.941-32.942V37.531c0-18.191 14.746-32.937 32.941-32.937h432.704c18.195 0 32.941 14.746 32.941 32.937v275.496c0 18.192-14.746 32.942-32.941 32.942zm0 0",
    fill: "url(#e)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 258.004v58.73c0 18.68 15.145 33.825 33.824 33.825h444.352c18.68 0 33.824-15.145 33.824-33.825v-58.73zm0 0",
    fill: "url(#f)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M466.91 322.844H45.09c-8.235 0-14.906-6.672-14.906-14.906V42.62c0-8.23 6.671-14.906 14.906-14.906h421.82c8.235 0 14.906 6.676 14.906 14.906v265.317c0 8.234-6.671 14.906-14.906 14.906zm0 0",
    fill: "url(#g)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M481.816 258.004H30.184v49.933c0 8.235 6.671 14.907 14.906 14.907h421.82c8.235 0 14.906-6.672 14.906-14.906zm0 0",
    fill: "url(#h)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M490.3 348.309a33.586 33.586 0 0 1-12.128 2.246H324.875l-5.188-5.188a3.639 3.639 0 0 1-1.644-3.039v-19.484h146.793zm0 0",
    fill: "url(#i)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m464.836 322.844-8.77-8.77a3.628 3.628 0 0 0-3.035-1.644H321.676a3.63 3.63 0 0 0-3.633 3.632v6.782zm0 0",
    fill: "url(#j)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M453.031 345.969H321.676a3.634 3.634 0 0 1-3.633-3.637v-26.27a3.63 3.63 0 0 1 3.633-3.632H453.03a3.63 3.63 0 0 1 3.633 3.632v26.27a3.634 3.634 0 0 1-3.633 3.637zm0 0",
    fill: "url(#k)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChalkboardEmpty);
export default __webpack_public_path__ + "static/media/chalkboard_empty.60dc086c683d690c0b5d28da602736f4.svg";
export { ForwardRef as ReactComponent };